import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { comercialPhoneBindingsService } from '@/services/comercialPhoneBindingsService'
import { visitSchedulingService, type NewAgentExclusion } from '@/services/visitSchedulingService'
import { queryKeys } from '../keys'

export function useExcludedAgentsQuery() {
  return useQuery({
    queryKey: queryKeys.excludedAgents.list(),
    queryFn: () => visitSchedulingService.listExcludedAgents(),
  })
}

/** El censo: la misma lista de `/actions` que dice quién es cada comercial. */
export function useAgentCensusQuery() {
  return useQuery({
    queryKey: queryKeys.excludedAgents.census(),
    queryFn: () => comercialPhoneBindingsService.list(),
  })
}

export function useExcludeAgent() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: NewAgentExclusion) => visitSchedulingService.excludeAgent(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.excludedAgents.list() }),
  })
}

export function useReadmitAgent() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (idGestor: string) => visitSchedulingService.readmitAgent(idGestor),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.excludedAgents.list() }),
  })
}
